import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Behfa_Interface, Empty_Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BehfaService } from 'src/app/Service/Behfa/Behfa.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-BehfaListAdmin',
  templateUrl: './BehfaListAdmin.component.html',
  styleUrls: ['./BehfaListAdmin.component.scss']
})
export class BehfaListAdminComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false
  BaseUrl=environment.BaseUrl

  selected_Record_Behfa:Behfa_Interface=Empty_Behfa_Interface()

  Form_Swicher_Name:string="List"

  set_Form_Swicher_Name(item:string)
  {
    this.Form_Swicher_Name=item
  }





  modalRef_Delete: any;

  constructor(
    private Behfa_Service:BehfaService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Behfa:Array<Behfa_Interface>=[]
  Data_Seleted_Delete:Behfa_Interface=Empty_Behfa_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1110).subscribe(
      data=>{
        this.ReadData_Behfa()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Behfa(){
    this.Procssing=true
    this.Behfa_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Behfa=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Behfa_Interface){
    item.deletingProccess=true
    this.modalRef_Delete.hide()
    this.Behfa_Service.DeleteBehfa(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Behfa()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Priority(item:Behfa_Interface){
    item.deletingProccess=true
    this.Behfa_Service.PriorityBehfa(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

        this.ReadData_Behfa()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  //#region TEXT

  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>متن خود را اینجا تایپ کنید ...</p>'
  };
  public config = {
    language: 'fa'
  };

  set_Form_Swicher_Name_For_Text_Edit(item:Behfa_Interface){
    this.Form_Swicher_Name='Text'
    this.selected_Record_Behfa=item
    this.model.editorData=item.val
  }

  set_Form_Swicher_Name_For_Text(){
    this.Form_Swicher_Name='Text'
    this.selected_Record_Behfa=Empty_Behfa_Interface()
  }


  onSubmitText(){
    this.Procssing=true
    this.selected_Record_Behfa.type=1
    this.selected_Record_Behfa.val=this.model.editorData
    this.Behfa_Service.AddEditBehfa(this.selected_Record_Behfa).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.selected_Record_Behfa=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion


  //#region Image


  InProccessing_image:boolean=false
  uploadimage(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_image=true

    this.Behfa_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.selected_Record_Behfa.val=data['filename']
        }
      }
    )
  }

  Remove_uploadimage(){
    this.selected_Record_Behfa.val=''
  }

  modalRef_Image: any;
  ModalimageUrl:String=''
  openModalImage(template: TemplateRef<any>,imageUrl:String) {
    this.ModalimageUrl=imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  onSubmitImage(){

    if(!this.selected_Record_Behfa.val)
    {
      this.Alertify_Service.ErrorMessage("عکس مورد نظر را انتخاب نمائید")
    }
    else{
      this.Procssing=true
      this.selected_Record_Behfa.type=2
      this.Behfa_Service.AddEditBehfa(this.selected_Record_Behfa).subscribe(
        data=>{
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.selected_Record_Behfa=data
          this.Procssing=false
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }

  set_Form_Swicher_Name_For_Image_Edit(item:Behfa_Interface){
    this.Form_Swicher_Name='Image'
    this.selected_Record_Behfa=item
    this.model.editorData=item.val
  }


  set_Form_Swicher_Name_For_Image(){
    this.Form_Swicher_Name='Image'
    this.selected_Record_Behfa=Empty_Behfa_Interface()
  }


  //#endregion


  //#region video

  VideoLink:string=''

  set_Form_Swicher_Name_For_Video(){
    this.Form_Swicher_Name='Video'
    this.VideoLink=''
    this.selected_Record_Behfa=Empty_Behfa_Interface()
  }

  set_Form_Swicher_Name_For_Video_Edit(item:Behfa_Interface){
    this.Form_Swicher_Name='Video'
    this.selected_Record_Behfa=item
    this.VideoLink=item.val
  }

  onSubmitVideo(){

    if(!this.VideoLink)
    {
      this.Alertify_Service.ErrorMessage("لینک ویدئو را وارد نمائید")
    }
    else{

      this.Procssing=true
      this.selected_Record_Behfa.type=3
      this.selected_Record_Behfa.val=this.VideoLink
      this.Behfa_Service.AddEditBehfa(this.selected_Record_Behfa).subscribe(
        data=>{
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.selected_Record_Behfa=data
          this.Procssing=false
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }


  }

  //#endregion

}
